import { useEffect, useState, type RefObject } from 'react';

const TRUNCATION_THRESHOLD_PX = 1;

export const useIsTruncated = (elementRef: RefObject<HTMLElement>) => {
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (!elementRef.current) {
      setIsTruncated(false);
      return;
    }

    const checkTruncation = () => {
      const element = elementRef.current;
      if (!element) return;

      const { width, height } = element.getBoundingClientRect();
      const widthOverflow = element.scrollWidth - width;
      const heightOverflow = element.scrollHeight - height;

      const truncated = widthOverflow > TRUNCATION_THRESHOLD_PX || heightOverflow > TRUNCATION_THRESHOLD_PX;
      setIsTruncated(truncated);
    };

    // Initial check with a small delay just to be sure :)
    const timeoutId = setTimeout(checkTruncation, 0);

    const resizeObserver = new ResizeObserver(checkTruncation);
    resizeObserver.observe(elementRef.current);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      resizeObserver.disconnect();
    };
  }, [elementRef]);

  return isTruncated;
};
